import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const input = "w-full border border-slate-300 rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-red-500";

export function DeleteAccountCard() {
  const { logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ password: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const ready = f.password && f.confirm.trim().toUpperCase() === "ELIMINA";
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/me/delete", f);
      const day = new Date(r.data.deletionScheduledFor).toLocaleDateString("it-IT");
      toast.success(`Account in cancellazione: i dati saranno eliminati il ${day}. Accedi prima di allora per annullare.`, { duration: 9000 });
      logout();
      nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Impossibile eliminare l'account");
    } finally { setLoading(false); }
  };
  return (
    <div className="mt-8 card-premium p-6 border-red-200" data-testid="delete-account-card">
      <div className="flex items-center gap-2 mb-1"><Trash2 className="w-5 h-5 text-red-600"/><h3 className="font-display text-xl font-bold">Elimina account</h3></div>
      <p className="text-sm text-slate-600">Il profilo sparisce subito dal portale. I dati personali (profilo, contatti, foto, documenti, calendario, chat, sponsorizzate e newsletter) vengono cancellati definitivamente dopo 30 giorni: se accedi di nuovo entro quella data la cancellazione viene annullata. Contratti e prenotazioni restano archiviati per 10 anni, come previsto dalla legge.</p>
      {!open ? (
        <button type="button" onClick={() => setOpen(true)} data-testid="delete-account-open" className="mt-4 inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-red-300 text-red-700 text-sm font-semibold hover:bg-red-50 transition-colors"><Trash2 className="w-4 h-4"/>Voglio eliminare il mio account</button>
      ) : (
        <form onSubmit={submit} className="mt-4 grid gap-3 max-w-md">
          <input type="password" required placeholder="La tua password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="delete-account-password" className={input}/>
          <input required placeholder='Scrivi ELIMINA per confermare' value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} data-testid="delete-account-confirm" className={input}/>
          <div className="flex gap-2">
            <button disabled={!ready || loading} data-testid="delete-account-submit" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-red-600 text-white text-sm font-bold hover:bg-red-700 transition-colors disabled:opacity-40"><Trash2 className="w-4 h-4"/>Elimina account</button>
            <button type="button" onClick={() => { setOpen(false); setF({ password: "", confirm: "" }); }} data-testid="delete-account-cancel" className="btn-pill-outline text-sm">Annulla</button>
          </div>
        </form>
      )}
    </div>
  );
}
